import styled from 'styled-components';
import { SecondaryButton } from 'ui/button';
import { BasicSelect } from 'ui/selects';
import { body2, colors, spacing, subtleShadow } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const ButtonGroup = styled.div`
  display: flex;
  gap: ${spacing.half};
`;

export const MediaLayoutLabel = styled.div`
  display: flex;
  gap: ${spacing.half};
  align-items: center;

  svg {
    width: ${spacing.double};
  }

  path {
    color: ${colors.iconSubtle};
  }
`;

export const CounterContainer = styled.div`
  display: flex;
  height: ${spacing.double};

  button {
    height: ${spacing.double};
    width: ${spacing.double};
    padding: 0;
  }

  button:first-of-type {
    border-radius: ${spacing.quarter} 0 0 ${spacing.quarter};
    border-right: none;
  }
  button:last-of-type {
    border-radius: 0 ${spacing.quarter} ${spacing.quarter} 0;
    border-left: none;
  }
`;

export const CounterLabel = styled.span`
  ${body2}
  color: ${colors.textSecondary};
  margin: auto 0;
  box-shadow: none;

  &:first-of-type {
    margin-right: ${spacing.half};
  }

  &:last-of-type {
    margin-left: ${spacing.half};
  }
`;

const COUNTER_SELECT_WIDTH = pxToRem(52);

export const CounterSelect = styled(BasicSelect)`
  width: ${COUNTER_SELECT_WIDTH};

  > div:first-child {
    height: ${spacing.double};
  }
  > div:last-child {
    min-width: ${COUNTER_SELECT_WIDTH};
    bottom: ${pxToRem(36)};
    top: unset;
  }

  #trigger-campaign-limit {
    height: 100%;
    border-radius: 0;
    box-shadow: none;

    button {
      height: 100%;

      div {
        padding: 0;
        text-align: center;
      }
    }
  }

  svg {
    display: none;
  }

  [role='listbox'] {
    width: 100%;
    padding: ${spacing.half};
    max-height: unset;
  }

  [data-test='campaign-limit-option'] {
    padding: ${spacing.threeEights} ${spacing.half};
    justify-content: center;
  }

  [data-test='basic-select-value-display'] {
    padding-left: ${spacing.base};
  }
`;

export const CounterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: -${spacing.single};
  align-items: center;
  border-radius: ${spacing.quarter};
  ${subtleShadow};
`;

export const OperatorButton = styled(SecondaryButton)`
  pointer-events: unset;

  &&& {
    box-shadow: none;
  }
`;

export const CustomTextFieldsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
  align-items: start;
  width: 100%;
`;

export const InputTextRow = styled.div`
  display: flex;
  gap: ${spacing.half};
  width: 100%;

  [data-test='input-wrapper'] {
    flex: 1;
  }
`;

export const ToggleRow = styled.div`
  ${body2}
  display: flex;
  gap: ${spacing.half};
  align-items: center;
  height: ${spacing.double};
`;

export const TogglesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.plusHalf};
`;

export const RawDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.quarter};
  width: 100%;

  button {
    justify-content: flex-start;
    width: fit-content;
  }
`;

export const Description = styled.div`
  ${body2};
  color: ${colors.textPrimary};
  word-break: break-word;
  max-width: ${spacing.x48};
`;
